"use client";

import { c as _c } from "react/compiler-runtime";
import { Badge, ItemAvatar, ItemContent, ItemSide, ItemTitle, List, Spinner, Tooltip } from "@opensea/ui-kit";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { Item } from "../../../../../components/Item";
import { isMetaMaskConnector } from "../../../../../polychain/hooks";
import { ConnectModalActions } from "../../../../../stores/connectModalStore";
import { useUninstalledWalletOptions } from "../MoreWalletOptions/useUninstalledWalletOptions";
import { useConnectOptions } from "./useConnectOptions";
export const WalletLogin = ({
  switchOnConnect,
  isLinking,
  connect
}) => {
  const t = useTranslations("wallet.WalletLogin");
  const uninstalledWalletOptions = useUninstalledWalletOptions();
  const hasUninstalledWalletOptions = uninstalledWalletOptions.length > 0;
  const connectOptions = useConnectOptions();
  const [selectedConnectOption, setSelectedConnectOption] = useState();
  const onConnectOptionClick = async option => {
    if (option.connectors.length > 1) {
      ConnectModalActions.setStep({
        id: "select-ecosystem",
        connectOption: option
      });
      return;
    }
    setSelectedConnectOption(option);
    try {
      await connect(option.connectors[0], {
        switchOnConnect
      });
    } finally {
      setSelectedConnectOption(undefined);
    }
  };
  return <List className="overflow-hidden rounded-xl bg-bg-primary">
      {connectOptions.map(connectOption => <Tooltip className="max-w-[380px] text-center" content={isMetaMaskConnector(connectOption.id) ? t("metamaskConnectedTooltip") : t("connectedTooltip", {
      walletName: connectOption.name
    })} disabled={isLinking ? true : !connectOption.isConnected} key={connectOption.id}>
          <div>
            <Item className="focus-visible:outline-none" disabled={!isLinking && (connectOption.id === selectedConnectOption?.id || connectOption.isConnected)} onClick={() => onConnectOptionClick(connectOption)}>
              {connectOption.icon && <ItemAvatar src={connectOption.icon} />}
              <ItemContent>
                <ItemTitle className="w-full truncate text-start">
                  {connectOption.name}
                </ItemTitle>
              </ItemContent>
              <WalletItemSide connectOption={connectOption} selectedConnectOption={selectedConnectOption} />
            </Item>
          </div>
        </Tooltip>)}
      {hasUninstalledWalletOptions && <Item onClick={() => ConnectModalActions.setStep({
      id: "more-wallet-options"
    })}>
          <ItemContent>
            <ItemTitle className="w-full truncate text-start">
              {t("moreWalletOptions")}
            </ItemTitle>
          </ItemContent>
        </Item>}
    </List>;
};
function WalletItemSide(t0) {
  const $ = _c(9);
  const {
    connectOption,
    selectedConnectOption
  } = t0;
  const t = useTranslations("wallet.WalletLogin");
  if (connectOption.isConnected) {
    let t1;
    if ($[0] !== t) {
      t1 = t("connected");
      $[0] = t;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <ItemSide><Badge variant="info">{t1}</Badge></ItemSide>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (connectOption.id === selectedConnectOption?.id) {
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ItemSide><Spinner size="xs" /></ItemSide>;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (connectOption.isInstalled) {
    let t1;
    if ($[5] !== t) {
      t1 = t("installed");
      $[5] = t;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    let t2;
    if ($[7] !== t1) {
      t2 = <ItemSide className="overflow-visible"><Badge variant="info">{t1}</Badge></ItemSide>;
      $[7] = t1;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  return null;
}